import type { UserProfile } from './types';

export let authCurrentUser: UserProfile | null = null;

let currentAuthUidProvider: () => string | undefined = () => undefined;

export function publishCurrentUserProfile(user: UserProfile | null): UserProfile | null {
    authCurrentUser = user;
    return authCurrentUser;
}

export function setCurrentAuthUidProvider(provider: () => string | undefined): void {
    currentAuthUidProvider = provider;
}

function getCurrentAuthUid(): string | undefined {
    return currentAuthUidProvider();
}

export function getEffectiveUserId(): string | undefined {
    const currentAuthUid = getCurrentAuthUid();
    if (currentAuthUid && authCurrentUser?.authUid === currentAuthUid) {
        return authCurrentUser.uid;
    }
    return currentAuthUid || authCurrentUser?.uid || undefined;
}

export function getAuthUid(): string | undefined {
    return getCurrentAuthUid() || authCurrentUser?.authUid || undefined;
}
